import CircularProgress from '@mui/material/CircularProgress';
import styled from "styled-components";

// Absolutely-positioned overlay that sits on top of a plot while its data is
// loading. The parent must be position:relative (all PlotSectionDiv variants
// already are). Shown only during the initial data fetch; background polling
// refreshes should not toggle the backing flag, so the plot never flickers.
const OverlayDiv = styled.div`
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    gap:12px;
    background:rgba(255,255,255,0.7);
    z-index:6;
`;

const OverlayLabel = styled.div`
    font-family:Helvetica,sans-serif;
    font-size:0.85em;
    color:#1d4d99;
`;

export const PlotLoadingOverlay = ({ show, label = 'Loading data…' }) => {
    if (!show) {
        return null;
    }
    return (
        <OverlayDiv>
            <CircularProgress size={48} sx={{ color: '#1d4d99' }} />
            <OverlayLabel>{label}</OverlayLabel>
        </OverlayDiv>
    );
};

export default PlotLoadingOverlay;
